/**
 * Theme front-end entry point.
 * Cart (drawer) and marquee JS live in their respective block view.js files.
 */

import '../css/frontend.scss';

import { initMenu } from './modules/menu.js';
import { initQuickAdd } from './modules/quick-add.js';
import { initNavSearch } from './modules/nav-search.js';
import { initProductGallery } from './modules/gallery.js';
import { initVariationSwatches } from './modules/variation-swatches.js';

initMenu();
initQuickAdd();
initNavSearch();
initProductGallery();
initVariationSwatches();
